// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TNZi","content":"styles_content__1mm7X","row":"styles_row__1vP0H","footer":"styles_footer__3_HFD","phraseLength":"styles_phraseLength__lQ-yq"};